export default Object.freeze({
  ProviderModuleName: 'ProviderManagementModule',
  ProviderLocationServiceModuleName: 'ProviderLocationServiceManagementModule',
  ProviderSpecialistModuleName: 'ProviderSpecialistManegmentModule',
  ProviderBillingHistoryModuleName: 'ProviderBillingHistoryModule',
  ProviderServicesMonthCertificationModuleName:
    'ProviderServicesMonthCertificationModule',
  ProviderEndTermModuleName: 'ProviderEndTermModule',
  ProviderVisitRegistryModuleName: 'ProviderVisitRegistryModule',
  ProviderContractDocumentConfigurationManagementModuleName:
    'ProviderContractDocumentConfigurationManagementModule',
  UspqrpContractModuleName: 'UspqrpContractModuleName',
  UspqrpContractSearchRequestModuleName:
    'UspqrpContractSearchRequestModuleName',
  UspqrpContractEditorModuleName: 'UspqrpContractEditorModuleName',
  MedicaidCertificationWrapper: 'MedicaidCertificationWrapper',
});
